import React, { Component } from 'react';

class Default extends Component {
  render() { 
    return (
        <div className="constainer">
          <div className="row">
            <div className="col-10 mx-auto text-center text-title pt-5">
              <h1 className=" m-3 display-3">
                ERROR 
              </h1>
              <h2> PAGE NOT FOUND </h2>
            </div>
          </div>
        </div>
      );
    }
}
 
export default Default;